/**
 * Styled Components - Created by gustavomedina on 20/03/18.
 */
import styled from 'styled-components'
import { BLUE } from '../../theme/colors'

export const Container = styled.div``

export const Text = styled.div`
  color: #fff;
`

export const YotpoHomeContainer = styled.div``

export const YotpoReviews = styled.div`
  max-width: 100%;
  @media (max-width: 1128px) {
    max-width: 100% !important;
    padding-left: 0px;
  }
  .yotpo-reviews-carousel-widget-container {
    width: 100% !important;
    max-width: 100vw !important;
    margin: 0px auto !important;
    }
  .yotpo-reviews-carousel-header {
    margin: 0px !important;
  }
  .y-slider-container .y-slide-left-animations {
    display: flex !important;
  }
  .yotpo-reviews-carousel .carousel-display-wrapper .yotpo-carousel .single-carousel {
    height: auto !important;
    padding: 18px !important;
    padding-bottom: 10px !important;
    @media (max-width: 698px) {
      padding: 2px !important;
      padding-bottom: 10px !important;
    }
  }
  .yotpo-reviews-carousel .carousel-display-wrapper .yotpo-carousel .big-version .carousel-stars {
    margin: 0px !important;
  }
  
  .yotpo-reviews-carousel .carousel-display-wrapper .stars-container {
    height: 26px !important;
    display: flex !important;
    margin-bottom: 6px !important;
  }
  .y-carousel-product-image {
    width: 103px !important;
    height: 108px !important;
    border: none !important;
    box-shadow: 1px 2px 3px 0px #adadad;
    filter: contrast(1.1) !important;
    background: #4e4e4e !important;
  }
  .y-carousel-product-image img {
    object-fit: cover !important;
    padding: 6px !important;
    height: 100% !important;
    width: 100% !important;
  }
  .yotpo-reviews-carousel .carousel-display-wrapper .yotpo-carousel 
  .y-slider-container .single-carousel .product-image-container .y-carousel-product-image img {
    height: 100% !important;
    width: 100% !important;
  }
  .carousel-site-quote-container {
    margin-top: 8px !important;
  }
  .carousel-site-quote {
    color: white !important;
  }
  #carousel-top-panel {
    padding-bottom: 28px !important;
    margin-bottom: 0px !important;
    border-bottom: none !important;
    @media (max-width: 1128px) {
      padding-bottom: 34px !important;
      margin-bottom: 2px !important;
      margin-top: -26px;
    }
  }
  .headline {
    font-family: Avenir !important;
    font-weight: bold !important;
    text-align: center !important;
    width: 100% !important;
    margin-bottom: -16px !important;
    display: block !important;
    font-size: 20px !important;
    @media (max-width: 1128px) {
      margin-bottom: 12px !important;
    }
  }
  .single-carousel {
    box-shadow: 1px 2px 4px 2px #d4d4d4;
    height: fit-content;
    border-radius: 5px;
    padding: 8px 2px;
    padding-bottom: 12px;
    margin-bottom: 30px;
    @media (min-width: 1128px) {
      padding: 6px 20px;
      margin-right: 50px !important;
    }
  }
  .small-version {
    @media (max-width: 1128px) {
      padding-left: 16px;
    }
  }
  .product-name {
    color: black !important;
    font-family: Avenir !important;
    height: fit-content !important;
    margin-top: 8px !important;
  }
  .carousel-review-title {
    font-family: Avenir !important;
  }
  .right-side.pull-right {
    width: 100%;
    max-width: 188px;
    margin-left: 12px;
    @media (max-width: 1128px) {
      max-width: 180px !important;
    }
    @media (max-width: 698px) {
      max-width: 170px !important;
    }
  }
  .carousel-review-body {
    color: black !important;
  }
  .carousel-review-author {
    color: #b46363 !important;
  }
  .carousel-review-body, .carousel-review-author {
    font-family: Avenir !important;
  }
  .yotpo-icon-star, .yotpo-icon-empty-star, .yotpo-icon-half-star {
    color: #ebb80c !important;
  }
  .carousel-read-more {
    color: ${BLUE} !important;
  }
  .review-product-image {
    width: 128px !important;
    height: 128px !important;
  }
  .review-product {
    height: unset !important;
  }
  .review-content {
    height: fit-content !important;
  }
  .glide__slides {
    align-items: unset !important;
  }
  .glide__slide {
    height: unset !important;
  }
  .reviews-carousel-card-container {
    min-height: 100% !important;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/YotpoHome/styledComponents.tsx